export default __webpack_public_path__ + "static/media/ritual-hero.f88b9068.png";